import { render, staticRenderFns } from "./TerritorialCommunities1946.vue?vue&type=template&id=2b7d03e9&"
import script from "./TerritorialCommunities1946.vue?vue&type=script&lang=js&"
export * from "./TerritorialCommunities1946.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports